import React from 'react'

// material ui
import Box from '@mui/material/Box'

// shared components
import Typography from '@mui/material/Typography'

const AllergiesSeverityInfo = props => (
  <Box py={2}>
    <Typography>
      Severe allergies:{' '}
      <Typography component='span' display='inline' color='text.secondary'>
        potentially life-threatening effects
      </Typography>
    </Typography>

    <Typography>
      Moderate allergies:{' '}
      <Typography component='span' display='inline' color='text.secondary'>
        causing discomfort but not life-threatening
      </Typography>
    </Typography>
  </Box>
)

export default AllergiesSeverityInfo
